module.exports = __webpack_public_path__ + "img/album-icon.75d32a43.png";